import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SolicitudDocumentosCpeViewModel, TDocumentoCertificadoPrevioExViewModel } from './documentosCpe.types';

@Injectable()
export class DocumentosCpeService {
    private fileEndpoint = this.baseUrl + 'api/core/file/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    //todos los documentos de una solicitud
    getCpeDocumentos(id: number): Observable<SolicitudDocumentosCpeViewModel> {
        return this.http.get<SolicitudDocumentosCpeViewModel>(this.baseUrl + 'api/exportacion/cpes/documentosCpe/' + id).pipe();
    }

    deleteDocumento(id: number): Observable<any> {
        return this.http.delete<TDocumentoCertificadoPrevioExViewModel>(this.baseUrl + 'api/exportacion/cpes/documentosCpe/' + id).pipe();
    }

    //obtener un documento concreto
    getDocumento(id: number): Observable<TDocumentoCertificadoPrevioExViewModel> {
        return this.http.get<TDocumentoCertificadoPrevioExViewModel>(this.baseUrl + 'api/exportacion/cpes/documentosCpe/documento/' + id).pipe();
    }

    //crear un documento
    createDocumento(documento: TDocumentoCertificadoPrevioExViewModel): Observable<any> {
        return this.http.post<TDocumentoCertificadoPrevioExViewModel>(this.baseUrl + 'api/exportacion/cpes/documentosCpe', documento).pipe();
    }

    editDocumento(documento: TDocumentoCertificadoPrevioExViewModel): Observable<any> {
        return this.http.put<TDocumentoCertificadoPrevioExViewModel>(this.baseUrl + 'api/exportacion/cpes/documentosCpe', documento).pipe();
    }

    deleteFile(guid: string): Observable<any> {
        return this.http.delete<string>(this.fileEndpoint + guid);
    }
}
